import axios from 'axios';
import { showErrorToast } from './showErrorToast';
import * as AppActionTypes from 'store/actions/appstate';
import { store } from 'store/store';

export const catchTableauReqCancel = (error, msg) => {
  if (axios.isCancel(error) === false) {
       store.dispatch({
          type: AppActionTypes.APPSTATE_SET_APP_ERROR,
          payload: msg
        });
      console.log('Cannot get tableau ticket ', error);
      showErrorToast("Launch Failed" , "Unable to launch report. Please try again.", "455px" , "355px" , "#88041E" , true);
  }
};
